export default "__VITE_ASSET__DMjD4OH2__"